import apiClient from './api'
import { authService } from './authService'

export interface InviteGuarantorData {
  email: string
  fullName: string
  phone: string
  rfc: string
  personType: 'PM' | 'PFAE'
}

export const guarantorService = {
  /**
   * Invita a un aval a participar en una solicitud de crédito
   * @param creditApplicationId ID de la solicitud de crédito
   * @param data Datos del aval
   * @returns Respuesta de la API
   */
  inviteGuarantor: async (
    creditApplicationId: string,
    data: InviteGuarantorData
  ) => {
    const token = authService.getToken()
    const headers = {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    }

    const response = await apiClient.post(
      `/credit-application/${creditApplicationId}/guarantor/invite`,
      data,
      { headers }
    )

    return response.data
  },

  /**
   * Finaliza el onboarding de un aval
   * @param linkedCreditApplicationId ID de la solicitud de crédito vinculada (del prospecto)
   * @returns Respuesta de la API
   */
  finalizeOnboarding: async (linkedCreditApplicationId: string) => {
    const response = await apiClient.post(
      `/credit-application/${linkedCreditApplicationId}/guarantor/finalize-onboarding`
    )

    return response.data
  },
}
